import { render, staticRenderFns } from "./SpinnerPage.vue?vue&type=template&id=91287fd4&"
import script from "./SpinnerPage.vue?vue&type=script&lang=js&"
export * from "./SpinnerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports